export enum HardshipRequiredDocsCardState {
  ADD = 'add',
  UPLOADING = 'uploading',
  ERROR = 'error',
  UPLOADED = 'uploaded',
  PENDING = 'pending',
  SUBMITTED = 'submitted',
}

export enum HardshipProgramType {
  HELPING_HANDS = 'HELPING_HANDS',
}

export enum DocumentType {
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED',
  OTHER = 'OTHER',
}

export enum QualificationTypeName {
  QUALIFYING_EVENT = 'QUALIFYING_EVENT',
  QUALIFYING_EXPENSE = 'QUALIFYING_EXPENSE',
}

export type HardshipEventType = string; // or keep enum if AIM standardizes

export enum HardshipApplicationStatus {
  DOCUMENTS_REQUESTED = 'DOCUMENTS_REQUESTED',
}

export enum ClientDocumentStatus {
  UPLOADED = 'UPLOADED',
  SUBMITTED = 'SUBMITTED'
}

export interface HardshipApiPayload {
  payload: {applications: HardshipApplication[]};
}

export interface HardshipApplication {
  id: string;
  createdDate: string;
  amountRequested: number;
  status: HardshipApplicationStatus | string;
  statusModifiedDate: string;
  config: HardshipConfig;
  clientDocuments: HardshipClientDocument[];
}

export interface HardshipConfig {
  type: HardshipProgramType;
  name: string;
  event: HardshipEventType;
  legalDocumentsKey: string;
  qualifiers: HardshipQualifierConfig[];
}

export interface HardshipQualifierConfig {
  key: QualificationTypeName;       // "QUALIFYING_EVENT"
  title: string;                    // translation key, e.g. "hardship_proof_of_situation"
  requiredCount: number;
  qualifyingDocuments: HardshipQualifyingDocumentConfig[];
}

/**
 * A document configuration under a qualifier.
 * This is the "what should be provided" definition, not an actual uploaded file.
 */
export interface HardshipQualifyingDocumentConfig {
  title: string;
  key: string;
  type: DocumentType;
}

/**
 * A client-uploaded document, keyed back to a config document via `key`.
 */
export interface HardshipClientDocument {
  documentId: string;
  key: string;                      // matches HardshipQualifyingDocumentConfig.key
  status: ClientDocumentStatus | string;
  createdDate: string;
}
